/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Test_JoinInputs */

const th_meeting_test_join = /** @type {(inputs: Meeting_Test_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เข้าห้อง`)
};

const en_meeting_test_join = /** @type {(inputs: Meeting_Test_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join room`)
};

const ja_meeting_test_join = /** @type {(inputs: Meeting_Test_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`入室`)
};

const zh_meeting_test_join = /** @type {(inputs: Meeting_Test_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`进入房间`)
};

const es_meeting_test_join = /** @type {(inputs: Meeting_Test_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrar en la sala`)
};

const pt_meeting_test_join = /** @type {(inputs: Meeting_Test_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrar na sala`)
};

const id_meeting_test_join = /** @type {(inputs: Meeting_Test_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk ruang`)
};

const fr_meeting_test_join = /** @type {(inputs: Meeting_Test_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejoindre le salon`)
};

const tl_meeting_test_join = /** @type {(inputs: Meeting_Test_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sumali sa silid`)
};

const vi_meeting_test_join = /** @type {(inputs: Meeting_Test_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vào phòng`)
};

const ko_meeting_test_join = /** @type {(inputs: Meeting_Test_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`방 참여`)
};

const de_meeting_test_join = /** @type {(inputs: Meeting_Test_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raum betreten`)
};

const ru_meeting_test_join = /** @type {(inputs: Meeting_Test_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войти в комнату`)
};

const tr_meeting_test_join = /** @type {(inputs: Meeting_Test_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odaya katıl`)
};

const it_meeting_test_join = /** @type {(inputs: Meeting_Test_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entra nella stanza`)
};

const pl_meeting_test_join = /** @type {(inputs: Meeting_Test_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wejdź do pokoju`)
};

const uk_meeting_test_join = /** @type {(inputs: Meeting_Test_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увійти до кімнати`)
};

const hi_meeting_test_join = /** @type {(inputs: Meeting_Test_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कक्ष में शामिल हों`)
};

const ar_meeting_test_join = /** @type {(inputs: Meeting_Test_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دخول الغرفة`)
};

const ms_meeting_test_join = /** @type {(inputs: Meeting_Test_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk bilik`)
};

const bn_meeting_test_join = /** @type {(inputs: Meeting_Test_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কক্ষে ঢুকুন`)
};

const zh_tw2_meeting_test_join = /** @type {(inputs: Meeting_Test_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`進入房間`)
};

const zh_hk2_meeting_test_join = /** @type {(inputs: Meeting_Test_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`進入房間`)
};

const ur_meeting_test_join = /** @type {(inputs: Meeting_Test_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کمرے میں جائیں`)
};

const fa_meeting_test_join = /** @type {(inputs: Meeting_Test_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ورود به اتاق`)
};

const sw_meeting_test_join = /** @type {(inputs: Meeting_Test_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingia chumbani`)
};

const nl_meeting_test_join = /** @type {(inputs: Meeting_Test_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruimte binnengaan`)
};

/**
* | output |
* | --- |
* | "Join room" |
*
* @param {Meeting_Test_JoinInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_test_join = /** @type {((inputs?: Meeting_Test_JoinInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Test_JoinInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_test_join(inputs)
	if (locale === "ja") return ja_meeting_test_join(inputs)
	if (locale === "zh") return zh_meeting_test_join(inputs)
	if (locale === "es") return es_meeting_test_join(inputs)
	if (locale === "pt") return pt_meeting_test_join(inputs)
	if (locale === "id") return id_meeting_test_join(inputs)
	if (locale === "fr") return fr_meeting_test_join(inputs)
	if (locale === "tl") return tl_meeting_test_join(inputs)
	if (locale === "vi") return vi_meeting_test_join(inputs)
	if (locale === "ko") return ko_meeting_test_join(inputs)
	if (locale === "de") return de_meeting_test_join(inputs)
	if (locale === "ru") return ru_meeting_test_join(inputs)
	if (locale === "tr") return tr_meeting_test_join(inputs)
	if (locale === "it") return it_meeting_test_join(inputs)
	if (locale === "pl") return pl_meeting_test_join(inputs)
	if (locale === "uk") return uk_meeting_test_join(inputs)
	if (locale === "hi") return hi_meeting_test_join(inputs)
	if (locale === "ar") return ar_meeting_test_join(inputs)
	if (locale === "ms") return ms_meeting_test_join(inputs)
	if (locale === "bn") return bn_meeting_test_join(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_test_join(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_test_join(inputs)
	if (locale === "ur") return ur_meeting_test_join(inputs)
	if (locale === "fa") return fa_meeting_test_join(inputs)
	if (locale === "sw") return sw_meeting_test_join(inputs)
	if (locale === "nl") return nl_meeting_test_join(inputs)
	return en_meeting_test_join(inputs)
});